import type { FC } from 'react';
import React from 'react';

import type { BaseSvgProps } from '../../utils';
import { sizeToSvgWidth } from '../../utils';

export const FragmentLogo: FC<BaseSvgProps> = ({
  width = sizeToSvgWidth.sm,
  'data-testid': testId = 'paymentbadge',
}) => (
  <svg
    width={width}
    height={width}
    className="shrink-0"
    data-testid={testId}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="12" height="12" fill="#0D0D0D" />
    <g transform="translate(3 3) scale(0.2)">
      <rect x="0.000213623" width="30.0001" height="8.40004" fill="white" />
      <rect y="10.8" width="19.2001" height="8.40004" fill="white" />
      <rect y="21.5999" width="8.40004" height="8.40004" fill="white" />
      <rect
        x="21.5991"
        y="10.8"
        width="8.40004"
        height="8.40004"
        fill="white"
      />
      <rect
        x="10.8002"
        y="21.5999"
        width="19.2"
        height="8.40004"
        fill="white"
      />
    </g>
  </svg>
);
